module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-upload"
  }, [_c('uploadSelect', {
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled,
      "max-limit": _vm.maxLimit,
      "is-auto": _vm.autoUpload,
      "accept": _vm.acceptType,
      "is-multiple": _vm.isMultiple,
      "file-list": _vm.fileList,
      "lastest-file": _vm.lastestFile,
      "show-progress": _vm.showProgress,
      "enable-head-image": _vm.enableHeadImage
    },
    on: {
      "on-file-change": _vm.onFileChange,
      "on-confirm-upload": _vm.uploadFile,
      "on-delete-file": _vm.onDeleteFile,
      "on-set-head-image": _vm.onSetHeadImage
    }
  }), _vm._v(" "), _vm._t("tips"), _vm._v(" "), _c('uploadList', {
    attrs: {
      "file-list": _vm.fileList,
      "disabled": _vm.disabled,
      "show-file-list": _vm.showFileList,
      "show-progress": _vm.showProgress
    },
    on: {
      "on-delete-file": _vm.onDeleteFile
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1864fcb4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-upload/upload.vue
// module id = 526
// module chunks = 0